import { render, staticRenderFns } from "./Step2.vue?vue&type=template&id=f08d2128&scoped=true"
import script from "./Step2.vue?vue&type=script&lang=js"
export * from "./Step2.vue?vue&type=script&lang=js"
import style0 from "./Step2.vue?vue&type=style&index=0&id=f08d2128&prod&lang=css"
import style1 from "./Step2.vue?vue&type=style&index=1&id=f08d2128&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f08d2128",
  null
  
)

export default component.exports